import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Component, inject, OnInit } from '@angular/core';
import {FormBuilder, Validators, FormsModule, ReactiveFormsModule, FormGroup} from '@angular/forms';
import { QuestionnaireSummary } from '../../models/questionnaireSummary.model';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DatePipe,DecimalPipe,CommonModule } from '@angular/common';
import { QuestionnaireAvailability, QuestionnaireService} from '../../service/questionnaire.service';
import { Router } from '@angular/router';
import { InclusionIndexDashboard } from '../../models/inclusionIndexDashboard';
import { CompanyService } from '../../service/company.service';
import { AlertService } from '../../service/alert.service';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationnDialogComponent } from '../../modal/confirmation-dialog/confirmation-dialog.component';
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import {MatTooltipModule} from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { InclusionIndexInformationsComponent } from '../../modal/inclusion-index-informations/inclusion-index-informations.component';
import { ensureUnicodePdfFont } from '../../shared/pdf-unicode-font.util';


@Component({
  selector: 'app-inclusion-index',
  standalone: true,
  templateUrl: './inclusion-index.component.html',
  styleUrl: './inclusion-index.component.css',
  imports: [MatIcon, DatePipe, DecimalPipe, CommonModule, MatProgressSpinner, AlertMessageComponent, MatTooltipModule, TranslateModule,RouterModule]
})
export class InclusionIndexComponent{


  constructor(private questionnaireService: QuestionnaireService,private alertService: AlertService,
              private route: Router, private companyService: CompanyService, private http: HttpClient,
            public dialog: MatDialog, private translate: TranslateService) {}
  selfPageIndex = 0;
  selfPageSize = 5;
  questionnairesTrainee: QuestionnaireSummary[] = [];
  questionnairesSelfAssessments: QuestionnaireSummary[] = [];
  dashboarInclusionIndexdData!: InclusionIndexDashboard;
  isQuestionnaireFilled = false;
  isQuestionnaireAvailable = false;
  tooltipReasonKey = '';
  tooltipReasonParams: Record<string, string> = {};
  isLoading = false;
  isRecalculatingAvailable = false;
  private readonly dimensionCodeToI18nKey: Record<string, string> = {
    'cultural': 'cultural.title',
    'integration': 'integration.title',
    'leadership': 'leadership.title',
    'mentorship': 'mentorship.title',
    'outcome': 'outcome.title'
  };

  private translateDimensionNameForPdf(dimensionCode: string) {
    return this.translate.instant(dimensionCode);
  }

  private async resolvePdfFontFamily(doc: jsPDF): Promise<string> {
    try {
      return await ensureUnicodePdfFont(doc);
    } catch (error) {
      console.error('Unable to load Unicode PDF font, falling back to Helvetica', error);
      return 'helvetica';
    }
  }

  ngOnInit(): void {

    this.isLoading = true;

    this.questionnaireService.getLast3TraineeQuestionnaires().subscribe({
      next: (data) => {
        this.questionnairesTrainee = data;
      },
      error: (err) => {
        console.error('Errore nel caricamento dei questionari tirocinante', err);
      }
    });

    /* this.questionnaireService.getTraineeQuestionnaires().subscribe({
      next: (data) => {
        this.questionnairesTrainee = data;
      console.log(this.questionnairesTrainee)

      },
      error: (err) => {
        console.error('Errore nel caricamento dei questionari tirocinante', err);
      }
    }); */

    this.questionnaireService.getSelfAssesments().subscribe({
      next: (data) => {
        this.questionnairesSelfAssessments = data;
      },
      error: (err) => {
        console.error('Errore nel caricamento degli autovalutazioni', err);
      }
    });

    this.loadDashboard();

        this.questionnaireService.canFillQuestionnaire().subscribe(
      (res: QuestionnaireAvailability) => {
        this.isQuestionnaireAvailable = res.canFill;
        this.tooltipReasonKey = res.reason || '';
        this.tooltipReasonParams = res.reasonParams ?? {};
      },
      err => {
        console.error('Errore nel controllo disponibilita questionario:', err);
        this.isQuestionnaireAvailable = false;
        this.tooltipReasonKey = 'inclusion-index.questionnaire-error-check';
        this.tooltipReasonParams = {};
      }
    );

    this.questionnaireService.isCompanyQuestionnaireFilled().subscribe(filled => {
      this.isQuestionnaireFilled = filled;
    });

    // Controlla se l'azienda ha un'autovalutazione per abilitare il ricalcolo
    this.companyService.hasSelfAssessment().subscribe({
      next: (hasSelfAssessment) => {
        console.log('hasSelfAssessment:', hasSelfAssessment);
        this.isRecalculatingAvailable = hasSelfAssessment;
      },
      error: (err) => {
        console.error('Errore nel controllo autovalutazione:', err);
        this.isRecalculatingAvailable = false;
      }
    });
  }

 /*  viewQuestionnaireCompany(company: QuestionnaireSummary) {
    console.log(company.questionnaireId)
    this.route.navigate(['/view-questionnaire', company.questionnaireId], 
    { queryParams: { returnUrl: '/inclusion-index'},
      state: {
          title: this.translate.instant('inclusion-index.self-assessment-title'),
          subtitle: this.translate.instant('inclusion-index.self-assessment-subtitle'),
          authorName: company.firstName,
          dateCompilation: company.dateCompilation
      }
    });

  } */

  openInfoDialog() {
    this.dialog.open(InclusionIndexInformationsComponent, {
      width: '680px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'inclusion-info-dialog-panel',
      autoFocus: false,
      hasBackdrop: true
    });
  }

  viewQuestionnaireCompany(company: QuestionnaireSummary) {
    this.route.navigate(['/view-questionnaire', company.questionnaireId], 
    { queryParams: { returnUrl: '/inclusion-index'},
      state: {
          title: this.translate.instant('inclusion-index.self-assessment-title'),
          subtitle: this.translate.instant('inclusion-index.self-assessment-subtitle'),
          authorName: company.firstName,
          dateCompilation: company.dateCompilation
      }
    });
}



  viewQuestionnaireTrainee(trainee: QuestionnaireSummary) {
    this.route.navigate(['/view-questionnaire', trainee.questionnaireId], 
                        { queryParams: { returnUrl: '/inclusion-index'},
                        state: {
                            title: this.translate.instant('inclusion-index.trainee-assessment-title'),
                            subtitle: this.translate.instant('inclusion-index.trainee-assessment-subtitle'),
                            authorName: `${trainee.firstName} ${trainee.lastName}`,
                            dateCompilation: trainee.dateCompilation,
                          }
                        });
  }

  viewAllTraineeAssessments() {
    this.route.navigate(['/all-trainee-assessments'], 
                        { queryParams: { returnUrl: '/inclusion-index'}
                        });
  }


  fillQuestionnaire() {

    if (!this.isQuestionnaireAvailable) {
      this.alertService.errorKey('inclusion-index.questionnaire-not-available');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    
    else{
    this.route.navigate(['/fill-questionnaire'],
                        { queryParams: { 
                          returnUrl: '/inclusion-index',
                          title: this.translate.instant('inclusion-index.self-assessment-title'),
                          subtitle: this.translate.instant('inclusion-index.self-assessment-subtitle')
                        }});
     }
  }

  toTrainingCourse() {
    this.route.navigate(['/training-course']);
  }

  recalculateIndex() {
    console.log('recalculateIndex chiamato, isRecalculatingAvailable:', this.isRecalculatingAvailable);
    
    if (!this.isRecalculatingAvailable) {
      this.alertService.errorKey('inclusion-index.recalculate-required-self-assessment');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
      width: '400px',
      data: { 
        message: this.translate.instant('inclusion-index.recalculate-confirm-message')
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.companyService.getNewIndex().subscribe({
          next: (message: string) => {
            console.log('Risposta backend:', message);
            this.alertService.success(message);
            this.loadDashboard();
            this.isLoading = false;
          },
          error: (err) => {
            console.error('Errore nel ricalcolo indice', err);
            this.alertService.error(this.translate.instant('inclusion-index.generic-error-prefix') + (err.error || err.message));
            this.isLoading = false;
          }
        });

      } else {
        this.isLoading = false; // reset se annulla
      }
    });
  }

  loadDashboard(): void {
    this.companyService.getInclusionIndexDashboard().subscribe({
      next: (data) => {
        this.dashboarInclusionIndexdData = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Errore nel caricamento dashboard', err);
        this.isLoading = false;
      }
    });
  }

  async exportQuestionnaire(questionnaireId: any): Promise<void> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    const results = await firstValueFrom(
      this.http.get<any[]>(environment.apiUrl + `/api/questionnaires/export/${questionnaireId}`, { headers })
    );

    if (!results || results.length === 0) {
      this.alertService.errorKey('inclusion-index.export-no-results');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const doc = new jsPDF({ unit: "mm", format: "a4" });
    const pdfFontFamily = await this.resolvePdfFontFamily(doc);
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;
    const contentWidth = pageWidth - marginX * 2;
    const headerContentStartY = 38;
    const footerReserve = 26;
    const contentBottomY = pageHeight - footerReserve;
    let currentY = headerContentStartY;

    const logoPath = '/img/logo_blue.png';
    const euLogoPath = '/img/eu_co_funded_en.jpg';
    const footerText = this.translate.instant('inclusion-index.pdf.footer-disclaimer');
    const projectNumber = "2021-1-IT02-KA220-VET-000028169";

    const pdfTitle = this.translate.instant('inclusion-index.pdf.self-assessment-questionnaire');
    const pdfCompiledBy = this.translate.instant('inclusion-index.pdf.compiled-by');
    const pdfDateCompilation = this.translate.instant('inclusion-index.pdf.date-compilation');
    const pdfTotalScore = this.translate.instant('inclusion-index.pdf.total-score');
    const pdfAverage = this.translate.instant('inclusion-index.pdf.average');
    const pdfTableIndex = this.translate.instant('inclusion-index.pdf.table-index');
    const pdfTableQuestion = this.translate.instant('inclusion-index.pdf.table-question');
    const pdfTableAnswer = this.translate.instant('inclusion-index.pdf.table-answer');
    const pdfProjectNumberLabel = this.translate.instant('inclusion-index.pdf.project-number-label');
    const pdfFilePrefix = this.translate.instant('inclusion-index.pdf.file-prefix');

    // Disegna header con loghi, titolo, info compilazione e data
    const drawPageHeader = (authorName: string, dateCompilation: string) => {
      try {
        doc.addImage(logoPath, "PNG", marginX, 6, 34, 9);
      } catch (error) {
        console.error("Error adding left logo", error);
      }

      try {
        doc.addImage(euLogoPath, "JPG", pageWidth - marginX - 48, 6, 48, 9);
      } catch (error) {
        console.error("Error adding EU logo", error);
      }

      doc.setDrawColor(214, 223, 239);
      doc.line(marginX, 19, pageWidth - marginX, 19);

      doc.setFont(pdfFontFamily, "bold");
      doc.setFontSize(13);
      doc.setTextColor(20, 32, 61);
      doc.text(pdfTitle, marginX, 26);

      doc.setFont(pdfFontFamily, "normal");
      doc.setFontSize(9);
      doc.setTextColor(51, 65, 85);
      doc.text(`${pdfCompiledBy}: ${authorName}`, marginX, 31);
      doc.text(`${pdfDateCompilation}: ${dateCompilation}`, pageWidth - marginX, 31, { align: "right" });

      currentY = headerContentStartY;
    };

    // Disegna footer con disclaimer, numero progetto e contatore pagine
    const drawPageFooter = (page: number, totalPages: number) => {
      const footerLines = doc.splitTextToSize(footerText, pageWidth - marginX * 2);
      const footerLineHeight = 3.1;
      const projectY = pageHeight - 6;
      const disclaimerY = projectY - 4 - ((footerLines.length - 1) * footerLineHeight);

      doc.setFontSize(7);
      doc.setTextColor(80, 80, 80);
      doc.setFont(pdfFontFamily, "normal");
      doc.text(footerLines, marginX, disclaimerY);

      doc.setFont(pdfFontFamily, "bold");
      doc.text(pdfProjectNumberLabel, marginX, projectY);
      doc.setFont(pdfFontFamily, "normal");
      doc.text(projectNumber, marginX + 23, projectY);
      doc.text(this.translate.instant('report-and-results.pdf.page', {page, totalPages}), pageWidth - marginX, projectY, { align: "right" });
    };

    results.forEach((result) => {
      doc.setFontSize(10);
      doc.setFont(pdfFontFamily,'bold');
      doc.setTextColor(20, 32, 61);
      doc.text(`${pdfTotalScore}: ${result.totalScore.toFixed(2)}`, marginX, currentY);
      currentY += 8;

      result.dimensions.forEach((dimension: any, dimIndex: number) => {
        const tableData = dimension.questions.map((q: any, i: number) => [
          i + 1,
          this.translate.instant(q.questionCode),
          q.answerValue
        ]);

        // Stima l'altezza della tabella: header (15mm) + righe (circa 10mm per riga) + margine (10mm)
        const estimatedTableHeight = 15 + (tableData.length * 10) + 10;

        // Se la tabella non entra nella pagina corrente, vai a una nuova pagina
        if (currentY + estimatedTableHeight > contentBottomY) {
          doc.addPage();
          currentY = headerContentStartY;
        }

        autoTable(doc, {
          head: [[
            {
              content: `${dimIndex + 1}. ${this.translateDimensionNameForPdf(dimension.dimensionCode)} (${pdfAverage}: ${dimension.average.toFixed(2)})`,
              colSpan: 3,
              styles: {
                fontStyle: 'bold',
                fontSize: 12,
                halign: 'left',
                fillColor: [240, 240, 240],
                textColor: [0, 0, 0]
              }
            }
          ],
          [
            pdfTableIndex,
            pdfTableQuestion,
            pdfTableAnswer
          ]],
          body: tableData,
          startY: currentY,
          margin: { left: marginX, right: marginX, bottom: footerReserve },
          styles: { fontSize: 10, font: pdfFontFamily },
          headStyles: {
            font: pdfFontFamily,
            fontStyle: 'bold',
            fillColor: [0, 51, 102],
            textColor: [255, 255, 255]
          },
          pageBreak: 'avoid',
          theme: 'grid',
          didDrawPage: (data) => {
            if (data.cursor) {
              currentY = data.cursor.y + 10;
            }
          }
        });
      });
    });

    // Applica header e footer a tutte le pagine
    const totalPages = doc.getNumberOfPages();
    const firstResultAuthorName = results[0]?.authorName || '';
    const firstResultDate = results[0]?.date || '';

    for (let page = 1; page <= totalPages; page++) {
      doc.setPage(page);
      drawPageHeader(firstResultAuthorName, firstResultDate);
      drawPageFooter(page, totalPages);
    }

    doc.save(`${pdfFilePrefix}-${questionnaireId}.pdf`);
  }

  inclusionLevelTranslate(): string|null|undefined {
    if (this.dashboarInclusionIndexdData.inclusionLevel == "Advanced")
      return "level-name.advanced"
    else if (this.dashboarInclusionIndexdData.inclusionLevel == "Intermediate")
      return "level-name.intermediate"
    else if (this.dashboarInclusionIndexdData.inclusionLevel == "Sufficient")
      return "level-name.sufficient"
    else if (this.dashboarInclusionIndexdData.inclusionLevel == "Insufficient")
      return "level-name.insufficient"
    else return "N/A"

    
  }
 
}


